var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettlements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.99 8.99999H19.42C18.6 6.99999 17 5.39999 15 4.57999V8.00999C15.37 8.28999 15.71 8.62999 15.99 8.99999ZM4 12C4 15.35 6.04 18.24 9 19.42V15.98C7.77 15.05 7 13.58 7 11.99C7 10.4 7.77 8.92999 9 7.99999V4.57999C6.04 5.75999 4 8.64999 4 12ZM15 15.99V19.42C17 18.6 18.6 17 19.42 15H15.99C15.71 15.37 15.37 15.71 15 15.99Z",
    fill: "#49e2b5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.82 11H21.95C21.48 6.27999 17.72 2.51999 13 2.04999V9.17999C13.85 9.48999 14.51 10.15 14.82 11ZM15 4.57999C17 5.39999 18.6 6.99999 19.42 8.99999H15.99C15.71 8.62999 15.37 8.28999 15 8.00999V4.57999ZM2 12C2 17.19 5.95 21.45 11 21.95V14.82C9.84 14.4 9 13.3 9 12C9 10.7 9.84 9.59999 11 9.17999V2.04999C5.95 2.54999 2 6.80999 2 12ZM9 4.57999V8.01999C7.77 8.93999 7 10.41 7 12C7 13.59 7.77 15.06 9 15.99V19.43C6.04 18.24 4 15.35 4 12C4 8.64999 6.04 5.75999 9 4.57999ZM13 14.82V21.95C17.72 21.48 21.48 17.72 21.95 13H14.82C14.51 13.85 13.85 14.51 13 14.82ZM15 15.99C15.37 15.71 15.71 15.38 15.99 15H19.42C18.6 17 17 18.6 15 19.42V15.99Z",
    fill: "#49e2b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlements);
export default __webpack_public_path__ + "static/media/settlements.05117aef.svg";
export { ForwardRef as ReactComponent };